import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InputSearch } from 'ui/inputs';
import { spacing } from 'ui/theme';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { DEBOUNCE_TIMEOUTS_MS, DISPLAY_TEXT } from '../constants';

const SearchBar = styled(InputSearch)`
  width: ${spacing.x16};
`;

type Props = {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
};

export const CustomEventsSearchInput = ({
  searchQuery: debouncedInputValue,
  setSearchQuery: setDebouncedInputValue,
}: Props) => {
  // Non-debounced input values
  const [inputValue, setInputValue] = useState(debouncedInputValue);

  // Updates to debouncedInputValue will trigger filtering of custom events
  const resetSearchDebouncer = useDebouncedEffect(
    () => setDebouncedInputValue(inputValue),
    [inputValue],
    {
      skipEffectOnMount: true,
      debounceTimeout: DEBOUNCE_TIMEOUTS_MS.search,
    },
  );

  useEffect(() => {
    // PAGINATION: add code for resetting page to 1
    resetSearchDebouncer();
    setInputValue(debouncedInputValue);
  }, [debouncedInputValue]);

  return (
    <SearchBar
      id="custom-events-search-input"
      onChange={setInputValue}
      placeholder={DISPLAY_TEXT.searchPlaceholder}
      value={inputValue}
    />
  );
};
